export default class pegMandatoryPhotoUpload extends HTMLElement {
	async connectedCallback() {
		await new Promise(requestAnimationFrame);
		this.abortController = new AbortController();
		this.#setEventListeners();
		this.#trackViewPage();
	}

	async disconnectedCallback() {
		await new Promise(requestAnimationFrame);
		this.abortController.abort();
	}

	#setEventListeners() {
		this.querySelector('#uploadPicture').addEventListener(
			'click',
			() => {
				this.#trackStartUpload();
			},
			{ signal: this.abortController.signal },
		);

		this.addEventListener(
			'pegPhotoUploader:uploadSuccess',
			() => {
				window.location.replace('/lists/partnersuggestions');
			},
			{ signal: this.abortController.signal },
		);
	}

	#trackStartUpload() {
		jPar.util.log.bigData({
			category: 'adaptive_blocking',
			subcategory: 'mandatory_photo_initialization_screen',
			action: 'click',
			targetId: 'click_button_upload',
		});
	}

	#trackViewPage() {
		jPar.util.log.bigData({
			category: 'adaptive_blocking',
			subcategory: 'mandatory_photo_initialization_screen',
			action: 'screen_view',
		});
	}
}
